"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_toolbar_menu_html_1 = __importDefault(require("./widget-toolbar-menu.html"));
(function (module) {
    var WidgetToolbarMenuController = function (prTextFormatsHelper, globalOptionsService, eventService) {
        var self = this;
        this.$onInit = function () {
            _.forEach(this.items, function (item) {
                item.label = $('<span style=\'' + getStyle(item) + '\';>' + item.name + '<span>');
                if (!item.notSelectable) {
                    item.selected = false;
                }
            });
        };
        this.clickAction = function ($item) {
            if (this.action) {
                $item.format = self.format;
                this.action({
                    $name: $item.format,
                    $value: $item.value
                });
            }
        }.bind(this);
        this.$onChanges = function (changes) {
            if (changes.selectedFormat) {
                _.forEach(this.items, function (item) {
                    if (!item.notSelectable) {
                        item.selected = false;
                    }
                });
            }
        };
        eventService.on('global-text-style-change', function () {
            _.forEach(self.items, function (item) {
                item.label = $('<span style=\'' + getStyle(item) + '\';>' + item.name + '<span>');
            });
        });
        this.getSelectedFormatLabel = function () {
            var currentFormatIndex = _.findIndex(this.items, { value: this.selectedFormat });
            return currentFormatIndex === -1 ? this.selectedFormat : this.items[currentFormatIndex].name;
        }.bind(this);
        function getStyle(item) {
            var style = '';
            if (self.format === 'font') {
                style = prTextFormatsHelper.getStyles({
                    FONT: item.value
                }, true);
            }
            if (self.format === 'header') {
                var textFormats = void 0;
                if (item.value === 'body') {
                    textFormats = globalOptionsService.getBodyTextFormats();
                }
                else {
                    textFormats = globalOptionsService.getTextFormats()[item.value];
                }
                if (textFormats) {
                    style = prTextFormatsHelper.getStyles(textFormats, true);
                }
            }
            return style;
        }
        if (!self.inputEnabled) {
            if (_.isUndefined(self.options)) {
                self.options = {};
            }
            self.options.className = 'pr-text-style';
        }
    };
    WidgetToolbarMenuController.$inject = ['prTextFormatsHelper', 'pr.globalOptionsService', 'prEventService'];
    module.controller('WidgetToolbarMenuController', WidgetToolbarMenuController);
    module.component('prWidgetToolbarMenu', {
        templateUrl: widget_toolbar_menu_html_1.default,
        bindings: {
            format: '<',
            items: '<',
            action: '&?',
            selectedFormat: '<',
            inputEnabled: '=',
            options: '<',
            tooltipDisabled: '<'
        },
        controller: 'WidgetToolbarMenuController'
    });
})(angular.module('qualtrics.pr'));
